import { createJSONStorage, persist } from 'zustand/middleware'
import { create } from 'zustand/react'
import { createUISlice, type UISlice } from '#app/stores/main/slices/ui.ts'
import { createSelectors } from '#app/stores/utils.ts'

type Store = UISlice

export const useStoreBase = create<Store>()(
	persist(
		(...a) => ({
			...createUISlice(...a),
		}),
		{
			name: 'sapienstone-storage',
			storage: createJSONStorage(() => sessionStorage),
			// Only persist background color, exclude visibleSections Map
			partialize: (state) => ({
				backgroundColor: state.backgroundColor,
			}),
		},
	),
)

export const useMainStore = createSelectors(useStoreBase)
